export default "__VITE_ASSET__BdscfSwL__"